<template>
  <div>
    <e-file-uploader v-model="fileList1" :single="false" :cat-list="catList" @completed="uploadCompleted1" file-ext="jpg" />
    {{ fileList1 }}
    <hr />
    <e-file-uploader v-model="fileList2" :single="true" :cat-list="catList" @completed="uploadCompleted2" file-ext="jpg,txt" file-size="10MB" />
    <!-- 파일 단위는 B(byte), KB(kilobyte), MB(megabyte), GB(gigabyte) 으로 설정 -->
    {{ fileList2 }}
    <hr />
  </div>
</template>

<script>
export default {
  components: {
    EFileUploader: () => import('@/components/common/EFileUploader')
  },
  data () {
    return {
      fileList1: [
        {
          guid: '1',
          originalName: '스크린샷, 2021-09-13 08-45-11.png',
          size: '4136833',
          fileId: 'http:/aaaa.ekmtc:990/asdfasdfasd', // 다운로드 URL (서버 호출)
          status: 'complete',
          contentType: 'image/png',
          category: 'value1'
        },
        {
          guid: '2',
          originalName: '스크린샷, 2021-09-13 08-45-11.png',
          size: '4136833',
          fileId: 'http:/aaaa.ekmtc:990/asdfasdfasd', // 다운로드 URL (서버 호출)
          status: 'complete',
          contentType: 'image/png',
          category: 'value2'
        }
      ],
      fileList2: [
        {
          guid: '1',
          originalName: '02 스크린샷, 2021-09-13 08-45-11.png',
          size: '4136833',
          fileId: 'http:/aaaa.ekmtc:990/asdfasdfasd', // 다운로드 URL (서버 호출)
          status: 'complete',
          contentType: 'image/png',
          category: 'value2'
        }
      ],
      // 카테고리가 있는 경우
      catList: [
        { category: 'category1', value: 'value1' },
        { category: 'category2', value: 'value2' }
      ]
    }
  },
  methods: {
    uploadCompleted1 (fileInfo) {
      console.log(fileInfo)
    },
    uploadCompleted2 (fileInfo) {
      console.log(fileInfo)
    }
  }
}
</script>
